import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { DatePipe } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../components/table/table.component';
import { Observable, of, switchMap } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../environments/environment';
import { MyMonitoringService } from '../../services/logging.service';
import { DialogModule } from 'primeng/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { AllRecordsService } from '../../services/allRecordsService';
import { DataUtils } from '../utils/DataUtils';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ApiService } from '../../services/apiservice';
import { DatePickerModule } from 'primeng/datepicker';
import { DatepickerComponent } from '../components/datepicker/datepicker.component';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
@Component({
  selector: 'app-call-by-districts-data',
  templateUrl: './callbydistricts.component.html',
  standalone: true,
  styleUrl: './callbydistricts.component.scss',
  imports: [DialogModule, DatepickerComponent, DatePickerModule, TableModule, ToastModule, TagModule, SelectModule, ButtonModule, InputTextModule, FormsModule, TableComponent, DropdownComponent, ProgressSpinnerModule, ConfirmPopupModule],
  providers: [MessageService, AllRecordsService, DatePipe, ConfirmationService]
})
export class CallByDistrictsComponent implements OnInit {
  @ViewChild('tblConfig') tblConfig!: TableComponent;

  router: any;
  param: any;
  processMessage: string = "";
  lsNorthDataColumns: any[] = [];
  criticalLoadDataCommentColumns: any[] = [];
  selectedItems: any[] = [];
  AppKeyValuePairs: any[] = [];
  actionButtons: any = [];
  isLoading: boolean = false;
  dialogVisible: boolean = false;
  cellValue: any[] = ['', ''];
  commentTable: any[] = [];
  //comments$: any[] = [];

  comments$!: Observable<any[]>;
  selectedRow: any;
  txtComment: any;
  user: any;
  districtOptions: SelectItem[] = [];
  dateTakenOptions: SelectItem[] = [];
  dispatchViewOptions: SelectItem[] = [];
  typeOptions: SelectItem[] = [];
  districtsMainCollection: any;
  selectedDistrict: any;
  selectedDataTaken: string = "";
  selectedDispatchView: any;
  selectedType: any;
  allDistrictData: any[] = [];
  selectDate: string = "Date Taken";
  totalRecords: number = 0;
  pageNumber: number = 1;
  pageSize: number = 10;

  queryParamData: any = {};


  sortField: string = "DateTaken";
  sortOrder: number = 0;
  searchText: any = "";


  filteredData$!: Observable<any[]>;


  constructor(
    private route: ActivatedRoute,
    private recordsService: AllRecordsService,
    private messageService: MessageService,
    private redirectRoute: Router,
    private monotoringService: MyMonitoringService, private datePipe: DatePipe,
    private confirmationService: ConfirmationService, private apiService: ApiService
  ) {
    this.router = route;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.param = params.get('tier');
      this.tblConfig.searchValue = this.param;
    });

    const temp = JSON.parse(sessionStorage.getItem("queryData")!);
    this.queryParamData = temp;
    if (temp) {
      this.selectedDistrict = temp.data.DistrictNm;
      this.selectedDispatchView = temp.data.Dispatch_Status;
      this.selectedDataTaken = temp.data.DateTaken;
      this.selectedType = temp.data.Type;
      this.getSelectedDistrictDetails();
      sessionStorage.removeItem("queryData")
    }
    this.LoadHeader();
    this.LoadDistrictDetails();
  }

  showDialog() {
    this.dialogVisible = true;
  }


  LoadHeader(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.lsNorthDataColumns = [
      { "field": "District", "header": "DISTRICT", "filter": true, "isSorting": true, "width": "10%" },

      { "field": "Type", "header": "TYPE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "DispatchStatus", "header": "DISPATCH STATUS", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "DateTaken", "header": "DATE TAKEN", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "State", "header": "STATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "City", "header": "CITY", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "House", "header": "HOUSE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Street", "header": "STREET", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Update", "header": "ACTION", "filter": false, "isSorting": false, "width": "10%", type: "action", isClickable: 'true', onclick: this.handleClick.bind(this) }
    ];


    this.commentTable = [
      { "field": "message", "header": "USER COMMENTS", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdUser", "header": "CREATE BY", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdDate", "header": "CREATE DATETIME", "filter": true, "isSorting": true, "width": "5%" },
    ]

  }



  uniqueData(data: any) {
    const uniqueData = data.filter((value: any, index: any, self: any) =>
      index === self.findIndex((t: any) => (
        t.label === value.label && t.value === value.value
      ))
    );

    const sortedData = uniqueData.sort((a: any, b: any) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });

    return sortedData;
  }

  sortedDate(data: any[]) {
    return data.sort((a, b) => {
      const dateA = new Date(a.value);
      const dateB = new Date(b.value);

      return dateA.getTime() - dateB.getTime(); // Compare the numeric time values of the Date objects
    });
  }

  removeDuplicateValues(data: any) {

    return data.reduce((acc: any, current: any) => {
      if (!acc.some((item: any) => item.label === current.label)) {
        acc.push(current);
      }
      return acc;
    }, []);

  }

  handleClick(rowData: any): void {
    this.redirectRoute.navigate(['/order-entry', rowData.CCR_ID]);
    const data = {
      DistrictNm: this.selectedDistrict,
      DateTaken: this.selectedDataTaken,
      Dispatch_Status: this.selectedDispatchView,
      Type: this.selectedType
    }
    const temp = {
      data,
      from: "/bydistricts"
    }
    sessionStorage.setItem("queryData", JSON.stringify(temp))
  }

  LoadDistrictDetails(): void {
    this.isLoading = true;
    this.processMessage = environment.appMessages.loadingMesage;

    this.apiService.groupId().pipe(
      switchMap(groupId => {
        return this.recordsService.getDistricts(groupId);
      })
    ).subscribe({
      next: (data: any) => {
        this.districtsMainCollection = data?.Payload;
        this.districtOptions = this.uniqueData(data?.Payload.DistrictData?.map((district: any) => ({
          label: district.District.trim(),
          value: district.District
        })));

        this.typeOptions = this.uniqueData(data?.Payload.OrderTypeData.map((district: any) => ({
          label: district.Value.trim(),
          value: district.Value
        })));

        this.dispatchViewOptions = this.uniqueData(data?.Payload?.DispatchStatusData.map((district: any) => ({
          label: district.Value.trim(),
          value: district.Value
        })))

        this.isLoading = false;

        if (this.queryParamData) {
          this.queryParamData = undefined;
        }
      },
      error: error => {
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg }); this.isLoading = false;
        this.monotoringService.logException({ name: 'CallByDistrictsComponent.LoadDistrictDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => { this.isLoading = false; }
    })
  }


  sortedData(data: any[]) {
    return data.sort((a, b) => {
      const dateA = new Date(a.value);
      const dateB = new Date(b.value);

      return dateA.getTime() - dateB.getTime(); // Compare the numeric time values of the Date objects
    });
  }

  updateDropdownValuesFromLoad() {

    const tempData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim());

    this.typeOptions = this.uniqueData(tempData.map((district: any) => ({
      label: district.Type.trim(),
      value: district.Type
    })));

    const tempDispatchData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim() && item.Type?.trim() === this.selectedType?.trim());


    this.dispatchViewOptions = this.uniqueData(tempDispatchData.map((district: any) => ({
      label: district.DispatchStatus.trim(),
      value: district.DispatchStatus
    })))

    const tempScheduledData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim() && item.Type?.trim() === this.selectedType?.trim() && item.DispatchStatus?.trim() === this.selectedDispatchView?.trim());

    const scheduledDta = this.uniqueData(tempScheduledData.map((district: any) => ({
      label: this.datePipe.transform(new Date(district.DateTaken.trim()), "MM-dd-yyyy")?.toString(),
      value: district.DateTaken?.trim()?.toString()
    })));

    const sortedScheduledData = DataUtils.filterDuplicates(this.sortedData(scheduledDta));
    this.dateTakenOptions = sortedScheduledData?.reverse();
  }


  updateDropdownValues() {
    if (this.selectedDistrict !== "" && this.selectedDataTaken === "" && this.selectedDispatchView === "" && this.selectedType === "") {
      const tempData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim());


      this.typeOptions = this.uniqueData(tempData.map((district: any) => ({
        label: district.Type.trim(),
        value: district.Type
      })));

    }

    if (this.selectedDistrict !== "" && this.selectedType !== "" && this.selectedDispatchView === "" && this.selectedDataTaken === "") {
      const tempData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim() && item.Type?.trim() === this.selectedType?.trim());


      this.dispatchViewOptions = this.uniqueData(tempData.map((district: any) => ({
        label: district.DispatchStatus.trim(),
        value: district.DispatchStatus
      })))



    }

    if (this.selectedDistrict !== "" && this.selectedType !== "" && this.selectedDispatchView !== "" && this.selectedDataTaken === "") {
      const tempData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim() && item.Type?.trim() === this.selectedType?.trim() && item.DispatchStatus?.trim() === this.selectedDispatchView?.trim());

      const scheduledDta = this.uniqueData(tempData.map((district: any) => ({
        label: this.datePipe.transform(new Date(district.DateTaken.trim()), "MM-dd-yyyy")?.toString(),
        value: district.DateTaken?.trim()?.toString()
      })));

      const sortedScheduledData = DataUtils.filterDuplicates(this.sortedData(scheduledDta));
      this.dateTakenOptions = sortedScheduledData?.reverse();


    }

  }

  getSelectedDistrictDetails(): void {
    this.isLoading = true;
    this.processMessage = environment.appMessages.loadingMesage;

    this.apiService.groupId().pipe(
      switchMap(groupId => {
        const payload = {
          DistrictNm: this.selectedDistrict === "" ? null : this.selectedDistrict,
          DateTaken: this.selectedDataTaken === "" ? null : this.selectedDataTaken,
          Dispatch_Status: this.selectedDispatchView === "" ? null : this.selectedDispatchView,
          Type: this.selectedType === "" ? null : this.selectedType,
          UserID: sessionStorage.getItem('userId'),
          RequestType: "District",
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          SortField: this.sortField,
          SortOrder: this.sortOrder,
          SearchText: this.searchText,
          groupId: groupId,
          HasDispatchStatus: true
        }
        return this.recordsService.getRecordDetails(payload);
      })
    ).subscribe({
      next: (data: any) => {
        const updatedData = data?.Payload?.Data?.map((item: any) => {
          return {
            ...item,
            DateTaken: this.datePipe.transform(new Date(item.DateTaken.trim()), "MM-dd-yyyy")?.toString()
          }
        });

        this.filteredData$ = of(updatedData);
        this.isLoading = false;

        this.totalRecords = data?.Payload?.TotalRecords;

        if (data?.Payload?.Data?.length === 0) {
          const errMsg = environment.appMessages.noData
          this.messageService.add({ severity: 'warn', summary: 'No Data', detail: errMsg, life: environment.appSettings.snakbarLife });
        }
      },
      error: error => {
        this.isLoading = false;
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CallByDistrictsComponent.getSelectedDistrictDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
      }

    });

  }

  onCellClicked(event: any[]) {
    this.isLoading = true;
    this.cellValue = event;
    this.selectedRow = event[1];
  }


  onCancelCommentClicked() {
    this.txtComment = "";
    this.dialogVisible = false;
  }

  onSaveCommentClicked() {

    this.isLoading = true;
    const cmt = { bqUniqueId: this.selectedRow.bqUniqueId, message: this.txtComment, createdUser: this.user, createdDate: Date() };
    if (cmt === null || cmt === undefined) {
      this.messageService.add({ severity: 'warning', summary: 'warning', detail: environment.appMessages.noChangesFound, life: environment.appSettings.snakbarLife });
      return;
    }

    this.processMessage = environment.appMessages.savinggMesage;
    this.isLoading = false;
  }

  reload() {
    this.tblConfig.clear();
    this.selectedItems = [];
    this.LoadHeader();
  }

  onReloadClicked() {
    this.reload();
  }

  onDistrictChange(event: any) {
    this.selectedDistrict = event;
  }

  onTypeChange(event: any) {
    this.selectedType = event;
  }


  onDateTakenChange(event: any) {
    this.selectedDataTaken = event;
  }

  onDispatchViewChange(event: any) {
    this.selectedDispatchView = event;
  }

  getSearchDisabledStatus() {
    return this.selectedDistrict === "" || this.selectedDataTaken === "" || this.selectedDispatchView === "" || this.selectedType === ""
  }



  onSearch(): void {
    this.pageNumber = 1;
    this.tblConfig.resetPage();
    this.getSelectedDistrictDetails();
  }

  onClear(): void {

    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      acceptButtonStyleClass: 'custom-accept-button',
      rejectButtonStyleClass: 'custom-reject-button',
      accept: () => {
        this.selectedType = "";
        this.selectedDispatchView = "";
        this.selectedDataTaken = "";
        this.selectedDistrict = "";
        this.selectedType = "";
        this.sortField = "";
        this.sortOrder = 1;
        this.searchText = "";
        this.filteredData$ = of([]);
        this.totalRecords = 0
        this.pageNumber = 1
        this.tblConfig.resetPage();
      },

    });
  }

  handlePageChange(event: any): void {
    this.pageNumber = event.page;
    this.pageSize = event.pageSize;
    this.getSelectedDistrictDetails();
  }

  onSearchText(event: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.pageNumber = 1
    this.tblConfig.resetPage();
    this.searchText = event.searchText;
    this.getSelectedDistrictDetails();
  }

  onSortClicked(event: any): void {
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.getSelectedDistrictDetails();
  }
}





